import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/banking/lib/CollectionsBootstrap'
import { AccountsPayableUpsellModal } from 'modules/finance/components/AccountsPayableUpsellModal'

const Container = () => {
  return (
    <>
      <AccountsPayableUpsellModal source="ap_banking_upsellcard"></AccountsPayableUpsellModal>
      <Outlet
        context={{
          loading: false,
        }}
      />
    </>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
